module.exports = __webpack_public_path__ + "static/media/dashRing.21d3bfde.svg";